import React, { useEffect, useState } from 'react'
import { Button, Modal, Space, Table } from 'antd'
import Icon from '@ant-design/icons'
import { AxiosResponse } from 'axios'
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons'
import ViewPage from '../../../../Components/ViewPage'
import FormCatProdutos from '../../../../Components/catProdutos'
import {
  delCategoriaProdutos,
  getCategoriaProdutos,
  TypeCategoriaProdutos,
} from '../../../../services/categoriaProdutos'
import { pagination } from '../../../../Components/Default'
import { IconAlert } from '../../../../Components/iconsAlert'
import { Notification } from '../../../../Components/notification'
import Icons from '../../../../Components/Icons'
import { tryError } from '../../../../services/Afins'
import { successAlert } from '../../../../utils/alert'

const CatProdutos: React.FC = () => {
  const [visibleForm, setVisibleForm] = useState(false)
  const [update, setUpdate] = useState(0)

  const [dataCatProdutos, setDataCatProdutos] = useState([])
  const [tempCatProdutos, setTempCatProdutos] = useState([])

  const [loadingTable, setLoadingTable] = useState(false)

  const listCatProdutos = async () => {
    try {
      setLoadingTable(true)
      const resp: AxiosResponse<TypeCategoriaProdutos> = await getCategoriaProdutos({
        pagination: -1,
      })

      setDataCatProdutos(resp.data.itens)
      setTempCatProdutos(resp.data.itens)
      setLoadingTable(false)
    } catch (error) {
      tryError(error)
    }
  }

  const handleClickNewTipo = () => {
    setVisibleForm(true)
  }

  const handleClickEdit = (cod) => {
    setUpdate(cod)
    setVisibleForm(true)
  }

  const handleSearch = (data) => {
    setLoadingTable(true)
    const dados = dataCatProdutos
    const nome: any = data.target.value.toLowerCase()

    setTimeout(() => {
      const response = dados.filter((info) => info.nome.toLowerCase().indexOf(nome) !== -1)
      setTempCatProdutos(response)
      setLoadingTable(false)
    }, 500)
  }

  const handleClickTrash = (cod, nome) => {
    Modal.confirm({
      title: `Deseja remover a categoria ${nome}?`,
      icon: <IconAlert type='confirm' size={6} />,
      okText: 'Sim',
      cancelText: 'Não',
      cancelButtonProps: {
        type: 'primary',
        danger: true,
      },
      onOk: async () => {
        const response = await delCategoriaProdutos(cod)

        if (response.status === 200) {
          successAlert('Categoria removida com sucesso!');

          listCatProdutos()
        }
      },
    })
  }

  const handleCloseForm = (data) => {
    setVisibleForm(data)
    if (data) {
      listCatProdutos()
    } else {
      setUpdate(0)
    }
  }

  useEffect(() => {
    listCatProdutos()
  }, [])

  return (
    <ViewPage
      title='Categoria de produtos'
      btnClick={handleClickNewTipo}
      search
      inputChange={handleSearch}
      content={
        <FormCatProdutos
          onClose={(data) => handleCloseForm(data)}
          open={visibleForm}
          update={update}
        />
      }
    >
      <Table
        rowKey='cod'
        loading={loadingTable}
        scroll={{ y: 'calc(90vh - 275px)' }}
        size='small'
        dataSource={tempCatProdutos}
        pagination={pagination}
        columns={[
          {
            key: 1,
            title: 'Nome',
            dataIndex: 'nome',
          },
          {
            key: 2,
            title: 'Categoria',
            dataIndex: 'grupo_categoria_produto_nome',
          },
          {
            key: 3,
            width: 90,
            title: 'Ações',
            dataIndex: 'cod',
            render: (data, record) => (
              <Space>
                <Button
                  shape='circle'
                  type='default'
                  onClick={() => handleClickEdit(data)}
                  icon={<Icon component={() => <Icons icon={faPen} />} />}
                />
                <Button
                  shape='circle'
                  type='primary'
                  danger
                  onClick={() => handleClickTrash(data, record.nome)}
                  icon={<Icon component={() => <Icons icon={faTrash} />} />}
                />
              </Space>
            ),
          },
        ]}
        footer={() => (
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'right',
            }}
          >
            <b>Total geral: {dataCatProdutos.length}</b>
          </div>
        )}
      />
    </ViewPage>
  )
}

export default CatProdutos
